module.exports = __webpack_public_path__ + "static/media/thumb.fd57c922.jpg";